module.exports = __webpack_public_path__ + "media/images/gm_icon05_sp-50703ec0351ffb12c95d1e036e5dbced.png";